import { useState } from "react";
import styled from "styled-components";
import Radio from '@material-ui/core/Radio';

const ModalHeader = styled.div`
font-weight: 700;
font-size: 24px;
line-height: 29px;
text-align: center;
margin: 20px 0 25px;
`;

const SimpleText = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 30px;
`

const FormLable = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #4B4B4D;
  margin: 25px 0 15px;
`

const Input = styled.input`
  width: ${({ width }) => width || '100%'};
  padding: 10px 15px;
  margin-bottom: 10px;
  border: 2px solid #ecedf0;
  border-radius: 14px;
  font-size: 18px;
  line-height: 30px;
  color: #000000;
  ::-webkit-input-placeholder {
    font-size: 18px;
    line-height: 30px;
    color: #bdbdc1;
  }
  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    display: none;
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
  @media (max-width: 610px) {
    line-height: 1;
    font-size: 5vw;
    padding: 3vw 4vw;
    border-radius: 3vw;
    margin-bottom: 5vw;
  }
`;

const CustomButton = styled.button`
  width: 100%;
  padding: 15px 0;
  border-radius: 30px;
  font-weight: 600;
  font-size: 18px;
  line-height: 22px;
  background: ${({ disabled }) => disabled ? '#BDBDC1' : '#222224'};
  background: ${({ isCancel }) => isCancel && '#ECEDF0'};
  color: ${({ isCancel }) => isCancel ? '#222224' : '#fff' };
  margin-top: 15px;
`

const RadioButton = styled.input`
type[radio]{

}
 border: 2px solid #ecedf0;
  .Mui-checked{
    color: #222224;
  }
`

const RadioLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${({isLast}) => isLast && '  margin-top: 25px;margin-bottom: 40px;'}
  label{
    width: 250px;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
  }
  

  input[type="radio"] {
	position: absolute;
	z-index: -1;
	opacity: 0;
	//margin: 10px 0 0 7px;
}
input[type="radio"] + label {
	position: relative;
	cursor: pointer;
}
input[type="radio"] + label:before {
	content: '';
	position: absolute;
	top: -3px;
	right: -85px;
	width: 25px;
	height: 25px;
	border:2px solid #ECEDF0;
	border-radius: 50%;
	background: #FFF;
}
input[type="radio"] + label:after {
	content: '';
	position: absolute;
	top: 0px;
	right: -82px;
	width: 19px;
	height: 19px;
	border-radius: 50%;
	background: #222224;
	opacity: 0;
	transition: .2s;
}
input[type="radio"]:checked + label:after {
	opacity: 1;
}
input[type="radio"]:checked + label:before{
    border: 2px solid #222224;

} 
`

export const ChurchHelperComponent = ({handleModalOpen, getChurchHelp, handleModalClose}) => {
  const initialValues = {
    requester_name: '',
    requester_email: '',
    church_name: '',
    church_website: '',
    not_showing_and_should_be: true,
    interested_in_using_togather: false
  }  
  const [extraData, setExtraData] = useState(initialValues)

  const isDisabled = extraData.requester_name && extraData.requester_email && extraData.church_name && extraData.church_website

  const handleInputChange = ({ target }) => {
    const { name, value } = target
    if (name === 'not_showing_and_should_be')
      return setExtraData({...extraData, [name]: true, ['interested_in_using_togather']: false})
    if (name === 'interested_in_using_togather')
      return setExtraData({ ...extraData, [name]: true, ['not_showing_and_should_be']: false })
    
    return setExtraData({...extraData, [name]: value})
  }

  const confirmHelp = () => {
    getChurchHelp(extraData)
    handleModalOpen('gratitude')
  }

  return (
    <>
      <ModalHeader>Don’t see your church?</ModalHeader>
      <SimpleText>Let us know a bit more and we’ll look into it.</SimpleText>
      <FormLable>Your church is</FormLable>
      <RadioLabel onClick={(e) => handleInputChange(e)}>
        <input
          id='error'
          name='not_showing_and_should_be'
          type='radio'
          checked={ extraData.not_showing_and_should_be }

        />
        <label for='error'>Not showing and should be</label>
      </RadioLabel>
      <RadioLabel isLast onClick={(e)=> handleInputChange(e)}>
        <input
          id='offer'
          name='interested_in_using_togather'
          type='radio'
          checked={ extraData.interested_in_using_togather }
        />
        <label for='offer'>Interested in using Togather</label>
      </RadioLabel>
      <FormLable>Church information</FormLable>
      <div>
        <Input
          placeholder="Church Name"
          name='church_name'
          value={ extraData.church_name }
          onChange={ handleInputChange }
        />
        <Input
          placeholder="Church Website"
          name='church_website'
          value={ extraData.church_website }
          onChange={ handleInputChange }
        />
      </div>
      <FormLable>Your information</FormLable>
      <div>
        <Input
          placeholder="Name"
          name='requester_name'
          value={ extraData.requester_name }
          onChange={ handleInputChange }
        />
        <Input
          placeholder="Email"
          name='requester_email'
          value={ extraData.requester_email }
          onChange={ handleInputChange }
        />
      </div>
      <div>
        <CustomButton
          onClick={ confirmHelp }
          disabled={ !isDisabled }
        >
          Submit
        </CustomButton>
        <CustomButton
          onClick={ handleModalClose }
          isCancel
        >
          Cancel
        </CustomButton>
      </div>
    </>
  )
}